import React from 'react';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function LevrantorRapport(props) {
    const  getLeverantor=(e)=>{
        if(e.target.value === "Alla"){
            props.onChangeHandle("Leverantör",e.target.value)
        }
        else{
            props.onChangeHandleMulti("Leverantör",e.target.value)
        }
    }
    return (
        <div>
        {isEmpty(props.Options)?"":
            <form>
                <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                    select
                    label={<IntlMessages id="Supplier" />}
                    variant="outlined"
                    size="small"
                    value={0}
                    fullWidth
                    onChange={getLeverantor}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option Key="0"  disabled value={0}><IntlMessages id="Choose"/></option>
                    <option Key="1" value={"Alla"}><IntlMessages id="All"/></option>
                    {props.Options.map((option) => (
                        <option key={option.id} value={option.operator}>
                            {option.operator}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
        }
            </div>
    );
}

export default LevrantorRapport;